import { render, staticRenderFns } from "./WorkCalendarTaskVariantContent.vue?vue&type=template&id=55b26254&scoped=true"
import script from "./WorkCalendarTaskVariantContent.vue?vue&type=script&lang=js"
export * from "./WorkCalendarTaskVariantContent.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarTaskVariantContent.vue?vue&type=style&index=0&id=55b26254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b26254",
  null
  
)

export default component.exports